import React from 'react';
import { SaraLogo } from '@/components/SaraLogo';

export const Footer = () => {
  return (
    <footer data-testid="footer" className="py-8 bg-hero">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center gap-4">
        <SaraLogo variant="dark" />
        <p className="text-[hsl(222_15%_55%)] text-sm">
          &copy; {new Date().getFullYear()} Sara Advertising PPC. All rights reserved.
        </p>
      </div>
    </footer>
  );
};
